<template>
  <b-link @click="resend_activation_email"> Resend Verification Email </b-link>
</template>

<script>
export default {
  methods: {
    resend_activation_email() {
      this.$http.post("/api/resend-activation-email").then((response) => {
        this.$store.commit("push_alert", {
          message: "Activation email sent",
          type: "info",
        });
      });
    },
  },
};
</script>
